module.exports = __webpack_public_path__ + "static/media/Comic Sans MS-01.c938d92e.svg";